
import { get, post, postImg } from "@/util/http"
import ApiContainer from "../url"
const scenicApi = {
  getScenicPointList: params => get(ApiContainer.getScenicPointList, params),  //获取场馆列表
  getScenicPointInfoById: params => get(ApiContainer.getScenicPointInfoById, params),//通过Id查询景点信息
  updateScenicPoint:params=>post(ApiContainer.updateScenicPoint,params),//更新场馆信息
}
export default scenicApi